import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full flex flex-col gap-6 pb-10" }

import { computed, onMounted, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useToast } from 'vue-toastification'

import Tabs, { type TabItem } from '@/components/designSystem/Tabs/Tabs.vue'
import { useUserStore } from '@/pinia-store/useUsersStore'
import { useHeaderStore } from '@/pinia-store/useHeaderStore'
import type { UserDataResponse } from '@/Network/Types/Responses/UserResponse'

import ProfileHeader from './components/atoms/ProfileHeader.vue'
import PersonalDataPanel from './components/organisms/PersonalDataPanel.vue'
import SecurityPanel from './components/organisms/SecurityPanel.vue'
import NotificationsPanel from './components/organisms/NotificationsPanel.vue'
import OrganizationsPanel from './components/organisms/OrganizationsPanel.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const userStore = useUserStore()
const headerStore = useHeaderStore()
const toast = useToast()

const { userData } = storeToRefs(userStore)

const activeTab = ref('personal')
const isUploadingAvatar = ref(false)

const tabList: TabItem[] = [
  { label: 'Dados pessoais', value: 'personal', testId: 'profile-tab-personal' },
  { label: 'Segurança', value: 'security', testId: 'profile-tab-security' },
  { label: 'Notificações', value: 'notifications', testId: 'profile-tab-notifications' },
  { label: 'Empresas', value: 'organizations', testId: 'profile-tab-organizations' }
]

const userName = computed(() => userData.value?.name || 'Usuário')

onMounted(async () => {
  headerStore.setTitle(
    'Perfil e Configurações',
    'Gerencie seus dados pessoais, segurança, notificações e empresas vinculadas.'
  )
  await userStore.getUserData()
})

const handleAvatarUpload = async (file: File) => {
  isUploadingAvatar.value = true
  try {
    await userStore.updateAvatar(file)
    toast.success('Foto de perfil alterada com sucesso!')
  } catch (error) {
    console.error('Erro ao enviar foto de perfil:', error)
    toast.error('Erro ao enviar foto de perfil. Tente novamente!')
  } finally {
    isUploadingAvatar.value = false
  }
}

const handleSavePersonalData = async (payload: Partial<UserDataResponse>) => {
  try {
    await userStore.updateUserData(payload)
    toast.success('Dados atualizados com sucesso!')
  } catch (error) {
    console.error('Erro ao atualizar os dados do usuário:', error)
    toast.error('Erro ao atualizar os dados. Tente novamente!')
    throw error // sinaliza falha ao painel (mantém o modo de edição)
  }
}

const handleChangePassword = async (payload: { password: string; repeatPassword: string }) => {
  try {
    await userStore.changePassword(payload.password, payload.repeatPassword)
    toast.success('Senha atualizada com sucesso!')
  } catch (error) {
    console.error('Erro ao atualizar a senha:', error)
    toast.error('Erro ao atualizar a senha. Tente novamente!')
    throw error // sinaliza falha ao painel (não limpa os campos)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ProfileHeader, {
      name: userName.value,
      email: _unref(userData)?.email,
      "avatar-url": _unref(userData)?.avatarUrl,
      "is-active": _unref(userData)?.isActive ?? true,
      confirmed: _unref(userData)?.confirmed ?? false,
      uploading: isUploadingAvatar.value,
      onUploadAvatar: handleAvatarUpload
    }, null, 8, ["name", "email", "avatar-url", "is-active", "confirmed", "uploading"]),
    _createVNode(Tabs, {
      modelValue: activeTab.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeTab).value = $event)),
      tabs: tabList
    }, {
      personal: _withCtx(() => [
        _createVNode(PersonalDataPanel, {
          "user-data": _unref(userData),
          save: handleSavePersonalData
        }, null, 8, ["user-data"])
      ]),
      security: _withCtx(() => [
        _createVNode(SecurityPanel, { save: handleChangePassword })
      ]),
      notifications: _withCtx(() => [
        _createVNode(NotificationsPanel)
      ]),
      organizations: _withCtx(() => [
        _createVNode(OrganizationsPanel)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})